import { useState } from 'react';
import Table from '@/components/ui/table/Table';
import { ActionLinks } from '@/components/ui/table/style';
import KPICard from '@/components/ui/analytics/KPICard';
import { useAuthStore } from '@stores/auth.store';
import { useStudents } from '@hooks/tenant/useStudents';
import { useTeachers } from '@hooks/tenant/useTeachers';
import { useStaffDirectory } from '@hooks/tenant/useStaffDirectory';
import {
    DashboardContainer,
    KPICardsGrid,
    TopSectionContainer
} from './style';

const Dashboard = () => {
    const [searchText, setSearchText] = useState('');
    const tenantId = useAuthStore((s) => s.user?.tenantId);
    const { total: studentsTotal = 0, kpis: studentKpis, loading: studentsLoading } = useStudents({ tenantId, includeRows: false });
    const { total: teachersTotal = 0, loading: teachersLoading } = useTeachers({ tenantId, includeRows: false });
    const { total: staffTotal = 0, loading: staffLoading } = useStaffDirectory({ tenantId, includeRows: false });

    const totalStudents = studentsLoading ? '—' : (studentKpis?.totalStudents ?? studentsTotal);
    const totalTeachers = teachersLoading ? '—' : teachersTotal;
    const totalStaff = staffLoading ? '—' : staffTotal;

    // Table Data - Recent Fee Payments
    const tableData = [];

    const columns = [
        {
            title: 'Receipt No',
            dataIndex: 'receiptNo',
            key: 'receiptNo',
        },
        {
            title: 'Student',
            dataIndex: 'student',
            key: 'student',
        },
        {
            title: 'Class',
            dataIndex: 'class',
            key: 'class',
        },
        {
            title: 'Fee Type',
            dataIndex: 'feeType',
            key: 'feeType',
        },
        {
            title: 'Amount',
            dataIndex: 'amount',
            key: 'amount',
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
        },
        {
            title: 'Date',
            dataIndex: 'date',
            key: 'date',
        },
        {
            title: 'Action',
            key: 'action',
            render: () => (
                <ActionLinks>
                    <a>View</a>
                </ActionLinks>
            ),
        },
    ];

    return (
        <DashboardContainer>
            <TopSectionContainer>
                <KPICardsGrid $columns={6} $rows={1}>
                    <KPICard title="Total Student" value={totalStudents} />
                    <KPICard title="Total Teachs" value={totalTeachers} />
                    <KPICard title="Total Staff" value={totalStaff} />
                    <KPICard title="Pending Fees" value="Rs. 0" />
                    <KPICard title="Fee Collection (This Month)" value="Rs. 0" />
                    <KPICard title="Leave Request" value="0" />
                </KPICardsGrid>
            </TopSectionContainer>

            <Table
                title="Recent Fee Payments"
                columns={columns}
                dataSource={tableData}
                emptyText="No data found"
                searchValue={searchText}
                onSearchChange={setSearchText}
                showFilter={true}
                showMore={true}
                pagination={true}
                pageSize={10}
                showSearch={true}
                showPagination={true}
            />
        </DashboardContainer>
    );
};

export default Dashboard;
